/**
 * 销售顾问营销漏斗分析 - 销售顾问
 */
export default {
  field_from_api: {
    /* arrived: {
      name: '到店'
    }, */
    review: {
      name: '草签数'
    },
    deal: {
      name: '成交数'
    },
    deal_rate: {
      name: '成交率'
    }
  },
  getData (params = {}) {
    this.$rest.dataAnalysis.getSaleFunnel(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
